var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "header"
  }, [_c("el-alert", {
    staticClass: "tips",
    attrs: {
      title: "使用扫描枪",
      description: "请使用扫描枪获取函证编号或手工录入函证编号(扫描枪扫入将自动分隔, 手工录入请使用半角逗号分隔)",
      type: "error"
    }
  }), _c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "函证单号",
      prop: "codes"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      placeholder: "请录入函证单号,以英文逗号隔开"
    },
    model: {
      value: _vm.form.codes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codes", $$v);
      },
      expression: "form.codes"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "快递单号",
      prop: "express"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入快递单号"
    },
    model: {
      value: _vm.form.express,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "express", $$v);
      },
      expression: "form.express"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading,
      size: "small"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm.errorMsg ? _c("el-alert", {
    attrs: {
      title: _vm.errorMsg,
      type: "error",
      "show-icon": ""
    }
  }) : _vm._e(), _vm.successMsg ? _c("el-alert", {
    attrs: {
      title: _vm.successMsg,
      type: "success",
      "show-icon": ""
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };